import React from "react";
import { Modal, Row, Col, Form, Container, InputGroup } from "react-bootstrap";
import parse from 'html-react-parser';

import CancelButton from "presentation/components/buttons/cancel";
import AddButton from "presentation/components/buttons/add";

import { handleChange } from "presentation/utils/functions/generic";


import { periodFormulaTypes, PERIOD_REPLACE_TYPE_EVALUATION_TYPE, PERIOD_REPLACE_TYPE_RESULT, PERIOD_REPLACE_TYPE_SPECIFIC_EVALUATION_TYPE } from "presentation/model/constants";
import { generatePeriodVirtualId } from "presentation/pages/evaluation-schemes/functions/periods";

class ManagePeriodModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            form: {}
        };
    }

    componentDidMount() {
        let { period = {} } = this.props;
        this.setState({ form: period });
    }

    componentDidUpdate(prevProps, prevState) {
        const { period = {} } = this.props;
        const { period: previousPeriodParam } = prevProps;

        if (period != previousPeriodParam) {
            this.setState({ form: period });
        }
    }

    onSubmit = () => {

        let { onClose, afterSubmit, component, periodKey } = this.props;
        let { form } = this.state;
        let { periods: existingPeriods } = component.state;
        let hasError = !form.stageId || !form.name;

        if (hasError) {
            this.setState({ loading: false, error: true, message: "Campos obrigatórios não foram preenchidos. Por favor, verifique a etapa e o nome do período. " });
        } else {

            let period = form;
            let existing = existingPeriods.filter(x => x.key == periodKey)[0];


            if (!existing) {
                let tempId = generatePeriodVirtualId();
                period.id = tempId;
                period.tempId = tempId;
                period.isVirtualId = true;
                period.key = periodKey;
            }

            let finalPeriods = [...existingPeriods.filter(x => x.key !== periodKey), period];

            component.setState({
                periods: finalPeriods,
                totalPeriodItems: finalPeriods.length
            }, () => {
                this.setState({
                    form: {}
                }, () => {
                    afterSubmit();
                    onClose();
                });
            });


        }
    };


    render() {
        let { show, onClose, stages, periods, evaluationTypes, mode = "add" } = this.props;
        let { loading, form } = this.state;
        let { stageId, formulaType } = form || {};

        const { onSubmit } = this;
        let component = this;
        let stageIdValue = stageId ? ("" + stageId) : "";
        let formulaTypeValue = formulaType ? ("" + formulaType) : "";

        return (
            <Modal size="lg" backdrop="static" show={show || false} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{mode == "add" ? "Adicionar período" : "Editar período"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Form.Label htmlFor="stageId">Etapa</Form.Label>
                                <Form.Select
                                    aria-label="Etapa"
                                    value={stageIdValue}
                                    id={`stageId`}
                                    name={`stageId`}
                                    data-field-name="stageId"
                                    onChange={(e) => handleChange(e, component)}
                                    required
                                >
                                    <option key="-1">Selecione</option>
                                    {stages.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                </Form.Select>
                            </Col>
                            <Col lg={6}>
                                <div className="form mt-2">
                                    <Form.Label htmlFor="name">Nome</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="name"
                                        name="name"
                                        defaultValue={form.name}
                                        onChange={(e) => handleChange(e, component)}
                                        aria-describedby="nameHelpBlock"
                                    />
                                    <Form.Text id="nameHelpBlock" muted>
                                        Informe o nome do período
                                    </Form.Text>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="form mt-2">
                                    <Form.Label htmlFor="displayName">Nome abreviado</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="displayName"
                                        name="displayName"
                                        defaultValue={form.displayName}
                                        onChange={(e) => handleChange(e, component)}
                                        aria-describedby="displayNameHelpBlock"
                                    />
                                    <Form.Text id="displayNamenameHelpBlock" muted>
                                        Informe o nome de exibição do período
                                    </Form.Text>
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div className="form mt-2">
                                    <Form.Label htmlFor="formulaType">Para calcular o resultado desse período, vou utilizar:</Form.Label>
                                    <Form.Select
                                        aria-label="Para calcular o resultado desse período, vou utilizar:"
                                        value={formulaTypeValue}
                                        id={`formulaType`}
                                        name={`formulaType`}
                                        data-field-name="formulaType"
                                        onChange={(e) => handleChange(e, component)}
                                        required
                                    >
                                        <option key="-1">Selecione</option>
                                        {periodFormulaTypes.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                    </Form.Select>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <h5 className="form mt-3 mb-3">
                                    Configurações gerais
                                </h5>
                                <div className="form mt-2">
                                    <Form.Check
                                        inline="true"
                                        type="checkbox"
                                        id="isHiddenInStudentResults"
                                        name="isHiddenInStudentResults"
                                        label={"Não exibir esse período no boletim do aluno"}
                                        checked={form.isHiddenInStudentResults}
                                        onChange={(e) => handleChange(e, component)}
                                    />
                                </div>
                                <div className="form mt-2">
                                    <Form.Check
                                        inline="true"
                                        type="checkbox"
                                        id="isIgnoredInStageDefaultFormula"
                                        name="isIgnoredInStageDefaultFormula"
                                        label={"Não incluir esse período no cálculo padrão do resultado da etapa"}
                                        checked={form.isIgnoredInStageDefaultFormula}
                                        onChange={(e) => handleChange(e, component)}
                                    />
                                </div>
                                <div className="form mt-2">
                                    <Form.Check
                                        inline="true"
                                        type="checkbox"
                                        id="replaceBehaviorIsActive"
                                        name="replaceBehaviorIsActive"
                                        label={"O resultado desse período irá substituir algum valor de outro(s) período(s)"}
                                        checked={form.replaceBehaviorIsActive}
                                        onChange={(e) => handleChange(e, component)}
                                    />
                                </div>
                            </Col>
                        </Row>
                        {form.replaceBehaviorIsActive && (
                            <Row>
                                <Col lg={12}>
                                    <hr />
                                </Col>
                                <Col>
                                    <h5 className="form mb-3">
                                        Configurações de substituição
                                    </h5>
                                </Col>
                                <Col lg={12}>
                                    <div className="form mt-2">
                                        <Form.Label htmlFor="periodFormulaType">Substituir o(s) resultado(s) do(s) período(s) abaixo</Form.Label>
                                        <Form.Select
                                            aria-label="Substituir o(s) resultado(s) do(s) periodo(s) :"
                                            defaultValue={form.periodsOverwritten}
                                            multiple
                                            id={`periodsOverwritten`}
                                            name={`periodsOverwritten`}
                                            data-field-name="periodsOverwritten"
                                            onChange={(e) => handleChange(e, component)}
                                            required
                                        >
                                            <option key="-1">Selecione</option>
                                            {periods.filter(x => x.stageId == form.stageId).map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                        </Form.Select>
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="form mt-2">
                                        <Form.Label htmlFor="repalceMethod">Tipo de substituição</Form.Label>

                                        <InputGroup className="mt-2">
                                            <InputGroup.Checkbox
                                                className="row-checkbox"
                                                type="radio"
                                                name="replaceMethod"
                                                data-field-name="replaceMethod"
                                                value={PERIOD_REPLACE_TYPE_EVALUATION_TYPE}
                                                checked={form.replaceMethod == PERIOD_REPLACE_TYPE_EVALUATION_TYPE}
                                                onChange={(e) => handleChange(e, component)}
                                                inline="true"
                                            />
                                            <InputGroup.Text> Substituir NOTA em avaliação no(s) período(s)</InputGroup.Text>
                                        </InputGroup>


                                        <InputGroup className="mt-2">
                                            <InputGroup.Checkbox
                                                className="row-checkbox"
                                                type="radio"
                                                name="replaceMethod"
                                                data-field-name="replaceMethod"
                                                value={PERIOD_REPLACE_TYPE_RESULT}
                                                checked={form.replaceMethod == PERIOD_REPLACE_TYPE_RESULT}
                                                onChange={(e) => handleChange(e, component)}
                                                inline="true"
                                            />
                                            <InputGroup.Text> Substituir RESULTADO do(s) período(s)</InputGroup.Text>
                                        </InputGroup>

                                        <InputGroup className="mt-2">
                                            <InputGroup.Checkbox
                                                className="row-checkbox"
                                                type="radio"
                                                name="replaceMethod"
                                                data-field-name="replaceMethod"
                                                value={PERIOD_REPLACE_TYPE_SPECIFIC_EVALUATION_TYPE}
                                                checked={form.replaceMethod == PERIOD_REPLACE_TYPE_SPECIFIC_EVALUATION_TYPE}
                                                onChange={(e) => handleChange(e, component)}
                                                inline="true"
                                            />
                                            <InputGroup.Text>Substituir especificamente o tipo de avaliação</InputGroup.Text>
                                            <Form.Select
                                                aria-label="Substituir especificamente o tipo de avaliação"
                                                defaultValue={form.replaceSpecificEvaluationTypeId}
                                                id={`replaceSpecificEvaluationTypeId`}
                                                name={`replaceSpecificEvaluationTypeId`}
                                                data-field-name="replaceSpecificEvaluationTypeId"
                                                onChange={(e) => handleChange(e, component)}
                                                required
                                            >
                                                <option key="-1">Selecione</option>
                                                {evaluationTypes.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                            </Form.Select>
                                        </InputGroup>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="form mt-2">
                                        <Form.Label htmlFor="gradeReplaceLimit">Limite para a substituição do valor</Form.Label>
                                        <Form.Control
                                            type="number"
                                            id="gradeReplaceLimit"
                                            name="gradeReplaceLimit"
                                            defaultValue={form.gradeReplaceLimit}
                                            onChange={(e) => handleChange(e, component)}
                                            aria-describedby="gradeReplaceLimitHelpBlock"
                                        />
                                        <Form.Text id="gradeReplaceLimitHelpBlock" muted>
                                            Caso houver, infrome o limite para substituição da nota/resultado do período
                                        </Form.Text>
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="form mt-3">
                                        <Form.Check
                                            inline="true"
                                            type="checkbox"
                                            id="replaceLowestPeriodValueOnly"
                                            name="replaceLowestPeriodValueOnly"
                                            label={"Substituir o menor valor"}
                                            checked={form.replaceLowestPeriodValueOnly}
                                            onChange={(e) => handleChange(e, component)}
                                        />
                                    </div>
                                    <div className="form mt-3">
                                        <Form.Check
                                            inline="true"
                                            type="checkbox"
                                            id="forceReplace"
                                            name="forceReplace"
                                            label={"Substituir o valor, mesmo que o antigo seja maior que o novo"}
                                            checked={form.forceReplace}
                                            onChange={(e) => handleChange(e, component)}
                                        />
                                    </div>
                                    <div className="form mt-3">
                                        <Form.Check
                                            inline="true"
                                            type="checkbox"
                                            id="replaceButDisplayOverwrittenValue"
                                            name="replaceButDisplayOverwrittenValue"
                                            label={"Substituir, mas mostrar o reusltado anterior à substuição"}
                                            checked={form.replaceButDisplayOverwrittenValue}
                                            onChange={(e) => handleChange(e, component)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton
                        containerProps={{
                            disabled: loading,
                            onClick: onClose
                        }}
                    />
                    <AddButton
                        title={"Salvar"}
                        containerProps={{
                            onClick: () => onSubmit(),
                            variant: 'success',
                            disabled: loading
                        }}
                    />
                </Modal.Footer>
            </Modal >
        );
    };
}

export default ManagePeriodModal;